// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import { MultiSelect } from 'primereact/multiselect'
import MultiSelectHeader from 'primereact-raytm-theme/MultiSelectHeader'
import MultiSelectFooter from 'primereact-raytm-theme/MultiSelectFooter'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

// styles
import style from '@aytm/app/stats/page/question-views/ad/styles/Controls.module.scss'

const Controls = ({ model, data, disabled, onConfigChange, isSurveyGuest }) => {
  const { config } = model

  const options = data.controls.metrics.options || []
  const values = config?.metrics || options.map(option => option.value)

  const buttonLabelTemplate = event => {
    const label =
      event != undefined && event.value != undefined && event.options.length === event.value.length
        ? `All`
        : event != undefined && event.value != undefined && 0 < event.value.length
          ? 1 === event.value.length
            ? `${event.options.find(o => o.value === event.value[0])[event.optionLabel]}`
            : `Filtered to ${event.value.length}`
          : event != undefined
            ? event.placeholder
            : 'Select...'

    return (
      <>
        <span dangerouslySetInnerHTML={{ __html: label }}></span>
      </>
    )
  }

  return isSurveyGuest ? null : (
    <div className={`${style.component} p-fluid`}>
      {0 < options.length ? (
        <>
          <div className="p-field">Metric types</div>
          <div className="p-field">
            <MultiSelect
              placeholder="Select..."
              value={values}
              options={options}
              optionValue="value"
              optionLabel="label"
              disabled={disabled || data.controls.metrics.disabled}
              filter={true}
              filterBy="search,label"
              filterPlaceholder="Search items"
              buttonLabelTemplate={buttonLabelTemplate}
              panelHeaderTemplate={MultiSelectHeader}
              panelFooterTemplate={MultiSelectFooter}
              onChange={
                disabled || data.controls.metrics.disabled ? null : event => onConfigChange('metrics', event.value)
              }
            />
          </div>
          <div className="p-field p-col-2">
            <Popup
              trigger="click"
              width="480px"
              direction="bottomleft"
              popupOffset={14}
              hideOtherPopupsOnShow
              content={() => (
                <div>
                  <p>Some metrics represent <strong>unique respondent behavior</strong>, while others represent <strong>specific respondent actions</strong>.</p>
                  <ul>
                    <li>
                      <strong>Respondent</strong> - Number of unique respondents.
                    </li>
                    <li>
                      <strong>Count</strong> - Total number of occurrences; a respondent may contribute multiple times.
                    </li>
                  </ul>
                  <p><strong>Examples</strong></p>
                  <ul>
                    <li>
                      <strong>Engagement</strong> is a <em>respondent</em> metric and represents the number of respondents who interacted with the ad at least once through a <strong>like, comment, save, or share</strong>. Each respondent is counted once, even if they perform multiple actions.
                    </li>
                    <li>
                      <strong>Likes, Comments, Saves, and Shares</strong> represent respondents who performed that <strong>specific action</strong>.
                    </li>
                  </ul>
                  <p>
                    Because <strong>Engagement counts unique respondents across all interaction types</strong>, the totals for Likes, Comments, Saves, and Shares will <strong>not sum to Engagement</strong>.
                  </p>
                  <p>
                    <em>Full definitions</em> available in the <a href="https://helpcenter.aytm.com/hc/en-us/articles/43437671801869-Analyzing-an-Ad-Test" target="_blank">
                      Help Article</a>.
                  </p>
                </div>
              )}
            >
              <i className="icon-aytmfd-help" />
            </Popup>
          </div>
          <></>
        </>
      ) : null}
    </div>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onConfigChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
